import { useEffect, useRef } from 'react';

import { isWebViewUserAgent } from './is-web-view';
import { useWebviewBridge } from './webview-bridge-context';
import { useWebviewEvents } from './webview-events';

/**
 * Fires `WEBVIEW:BRIDGE_READY` once, as soon as the bridge is initialized, so
 * native knows when it can safely start posting messages to the web. Mounted
 * directly under WebviewBridgeProvider — above the auth render gate — so the
 * signal doesn't wait for authentication to resolve.
 */
export const WebviewReadySignal = () => {
  const { isInitialized } = useWebviewBridge();
  const { sendBridgeReady } = useWebviewEvents();
  const sentRef = useRef(false);

  useEffect(() => {
    if (!isWebViewUserAgent() || !isInitialized || sentRef.current) {
      return;
    }
    sentRef.current = true;
    sendBridgeReady().catch((): void => undefined);
  }, [isInitialized, sendBridgeReady]);

  return null;
};
